var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroCube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.664 107.066L33.062 54.919l54.445-26.397 18.805 51.954-52.648 26.59z",
    fill: "url(#hero-cube_svg__paint0_linear_957_2555)",
    stroke: "#484557",
    strokeWidth: 0.593
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.647 89.068L11.645 38.705l21.342 16.039 20.774 52.063-22.114-17.74z",
    fill: "url(#hero-cube_svg__paint1_linear_957_2555)",
    stroke: "#484557",
    strokeWidth: 0.593
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.084 54.924l-21.468-16.19 49.447-23.975 26.465 13.768-54.444 26.397z",
    fill: "url(#hero-cube_svg__paint2_linear_957_2555)",
    stroke: "#484557",
    strokeWidth: 0.593
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero-cube_svg__paint0_linear_957_2555",
    x1: 47.026,
    y1: 48.149,
    x2: 86.86,
    y2: 95.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A59AE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#BCC3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404,
    stopColor: "#B1CAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8192F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero-cube_svg__paint1_linear_957_2555",
    x1: 12.548,
    y1: 38.267,
    x2: 63.221,
    y2: 46.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A59AE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#BCC3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404,
    stopColor: "#B1CAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8192F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero-cube_svg__paint2_linear_957_2555",
    x1: 31.576,
    y1: 29.056,
    x2: 45.732,
    y2: 52.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A59AE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#BCC3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404,
    stopColor: "#B1CAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8192F7"
  })))));
}
export default "data:image/svg+xml;base64,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";
export { SvgHeroCube as ReactComponent };